module.exports = __webpack_public_path__ + "static/og-27959ca464964f0e34210c9d3d1aaca5.png";